import React from 'react';

const AdSpace = () => {
  return (
   <div style={{ textAlign: 'center', color: '#999', padding: '20px' }}>
            <p>Google AdSense</p>
            <p style={{ fontSize: '0.9rem' }}>Rectangle (2 columns)</p>
            {/* Example AdSense slot (replace publisher and slot IDs) */}
            {/**
            <ins className="adsbygoogle"
              style={{ display: 'block' }}
              data-ad-client="ca-pub-XXXXXXXXXXXX"
              data-ad-slot="YYYYYYYYYY"
              data-ad-format="auto"
              data-full-width-responsive="true"></ins>
            <script>(adsbygoogle = window.adsbygoogle || []).push({});</script>
            */}
    </div>
  );
};

const styles = {
  container: {
    width: '100%',
    maxWidth: '300px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    position: 'sticky',
    top: '80px',
  },
  adPlaceholder: {
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '15px',
    textAlign: 'center',
    height: '100%',
    minHeight: '600px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  adText: {
    fontSize: '0.85rem',
    color: '#999',
    margin: '0 0 10px 0',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  adInner: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ccc',
    fontSize: '0.9rem',
  },
};

export default AdSpace;
